<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center justify-between gap-3 mb-6">
    <div class="flex items-center gap-3">
      <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">account_balance</mat-icon>
      <h1 class="text-xl md:text-2xl font-bold text-gray-800">Gestión de Comisiones Bancarias - Venezuela</h1>
    </div>
    <button type="button" (click)="toggleFilters()"
      style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 16px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 8px; font-weight: 600; font-size: 0.8rem; cursor: pointer; transition: background 0.2s ease; white-space: nowrap;"
      onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #374151;">{{ showFilters ? 'filter_alt_off' : 'filter_alt' }}</mat-icon>
      {{ showFilters ? 'Ocultar' : 'Filtros' }}
    </button>
  </div>

  <!-- Candado de edición (solo producción). Ver AdminEditPermissionsService -->
  <app-solo-lectura-banner *ngIf="!puedeEditar"
    detalle="La creación, edición y activación de comisiones bancarias está reservada al operador autorizado. Los filtros y el historial siguen disponibles.">
  </app-solo-lectura-banner>

  <!-- Card Filtros -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6" *ngIf="showFilters">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">filter_list</mat-icon>
        Filtros
      </h2>
    </div>
    <div class="p-5">
      <form [formGroup]="filterForm">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Banco</mat-label>
            <mat-select formControlName="bancoId">
              <mat-option [value]="null">Todos</mat-option>
              <mat-option *ngFor="let banco of bancos" [value]="banco.bancoID">{{ banco.nombre }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Tipo de Cuenta</mat-label>
            <mat-select formControlName="tipoCuenta">
              <mat-option [value]="null">Todas</mat-option>
              <mat-option *ngFor="let tipo of tiposCuenta" [value]="tipo">{{ getTipoCuentaLabel(tipo) }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Tipo de Operación</mat-label>
            <mat-select formControlName="tipoOperacion">
              <mat-option [value]="null">Todas</mat-option>
              <mat-option *ngFor="let tipo of tiposOperacion" [value]="tipo">{{ getTipoOperacionLabel(tipo) }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Estado</mat-label>
            <mat-select formControlName="activo">
              <mat-option [value]="null">Todos</mat-option>
              <mat-option [value]="true">Activos</mat-option>
              <mat-option [value]="false">Inactivos</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex flex-col sm:flex-row justify-center gap-3 mt-4">
          <button type="button" (click)="applyFilter()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
            Filtrar
          </button>
          <button type="button" (click)="clearFilter()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">clear</mat-icon>
            Limpiar
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Botón Crear -->
  <div class="mb-4" *ngIf="!showForm">
    <button [disabled]="!puedeEditar" type="button" (click)="openCreateForm()"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">add</mat-icon>
      Nueva Comisión
    </button>
  </div>

  <!-- Card Formulario Crear/Editar -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6" *ngIf="showForm">
    <div style="background: linear-gradient(135deg, #fef3c7, #fde68a); padding: 16px 24px; border-bottom: 2px solid #fbbf24;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #92400e; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #92400e;">{{ isEditing ? 'edit' : 'add_circle' }}</mat-icon>
        {{ isEditing ? 'Actualizar Comisión' : 'Crear Nueva Comisión' }}
      </h2>
    </div>
    <div class="p-5">
      <form [formGroup]="comisionForm">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Banco *</mat-label>
            <mat-select formControlName="bancoId">
              <mat-option *ngFor="let banco of bancos" [value]="banco.bancoID">{{ banco.nombre }}</mat-option>
            </mat-select>
            <mat-error *ngIf="comisionForm.get('bancoId')?.hasError('required')">El banco es requerido</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Tipo de Cuenta *</mat-label>
            <mat-select formControlName="tipoCuenta">
              <mat-option *ngFor="let tipo of tiposCuenta" [value]="tipo">{{ getTipoCuentaLabel(tipo) }}</mat-option>
            </mat-select>
            <mat-error *ngIf="comisionForm.get('tipoCuenta')?.hasError('required')">El tipo de cuenta es requerido</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Tipo de Operación *</mat-label>
            <mat-select formControlName="tipoOperacion">
              <mat-option *ngFor="let tipo of tiposOperacion" [value]="tipo">{{ getTipoOperacionLabel(tipo) }}</mat-option>
            </mat-select>
            <mat-error *ngIf="comisionForm.get('tipoOperacion')?.hasError('required')">El tipo de operación es requerido</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Tipo de Valor *</mat-label>
            <mat-select formControlName="tipoValor">
              <mat-option value="porcentaje">Porcentaje</mat-option>
              <mat-option value="fijo">Fijo</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="modern-field" *ngIf="comisionForm.get('tipoValor')?.value === 'porcentaje'">
            <mat-label>Porcentaje (%) *</mat-label>
            <input matInput type="number" formControlName="porcentaje" min="0" max="100" step="0.01">
            <mat-hint>Hasta 2 decimales</mat-hint>
            <mat-error *ngIf="comisionForm.get('porcentaje')?.hasError('required')">El porcentaje es requerido</mat-error>
            <mat-error *ngIf="comisionForm.get('porcentaje')?.hasError('min')">Debe ser >= 0</mat-error>
            <mat-error *ngIf="comisionForm.get('porcentaje')?.hasError('max')">Debe ser <= 100</mat-error>
            <mat-error *ngIf="comisionForm.get('porcentaje')?.hasError('invalidDecimals')">Máximo 2 decimales</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="modern-field" *ngIf="comisionForm.get('tipoValor')?.value === 'fijo'">
            <mat-label>Valor Fijo (Bs) *</mat-label>
            <input matInput type="number" formControlName="valorFijo" min="0" step="0.01">
            <mat-hint>Hasta 2 decimales</mat-hint>
            <mat-error *ngIf="comisionForm.get('valorFijo')?.hasError('required')">El valor fijo es requerido</mat-error>
            <mat-error *ngIf="comisionForm.get('valorFijo')?.hasError('min')">Debe ser >= 0</mat-error>
            <mat-error *ngIf="comisionForm.get('valorFijo')?.hasError('invalidDecimals')">Máximo 2 decimales</mat-error>
          </mat-form-field>
        </div>

        <div class="flex flex-col sm:flex-row justify-center gap-3 mt-4">
          <button [disabled]="!puedeEditar" type="button" (click)="saveComision()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">save</mat-icon>
            {{ isEditing ? 'Actualizar' : 'Crear' }}
          </button>
          <button type="button" (click)="cancelForm()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">cancel</mat-icon>
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Card Tabla Comisiones -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">list_alt</mat-icon>
        Listado de Comisiones
      </h2>
    </div>

    <!-- Tabla Desktop -->
    <div class="hidden lg:block overflow-x-auto">
      <table mat-table [dataSource]="dataSource" class="w-full">
        <ng-container matColumnDef="banco">
          <th mat-header-cell *matHeaderCellDef>Banco</th>
          <td mat-cell *matCellDef="let element"><span class="text-xs">{{ getBancoNombre(element.bancoId) }}</span></td>
        </ng-container>

        <ng-container matColumnDef="tipoCuenta">
          <th mat-header-cell *matHeaderCellDef>Tipo Cuenta</th>
          <td mat-cell *matCellDef="let element">
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full"
              [style.background]="element.tipoCuenta === 'personal' ? '#dbeafe' : '#fef3c7'"
              [style.color]="element.tipoCuenta === 'personal' ? '#1e40af' : '#92400e'">
              {{ getTipoCuentaLabel(element.tipoCuenta) | uppercase }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="tipoOperacion">
          <th mat-header-cell *matHeaderCellDef>Tipo de Operación</th>
          <td mat-cell *matCellDef="let element"><span class="text-xs">{{ getTipoOperacionLabel(element.tipoOperacion) }}</span></td>
        </ng-container>

        <ng-container matColumnDef="tipoValor">
          <th mat-header-cell *matHeaderCellDef>Tipo Valor</th>
          <td mat-cell *matCellDef="let element">
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full"
              [style.background]="element.tipoValor === 'porcentaje' ? '#dcfce7' : '#dbeafe'"
              [style.color]="element.tipoValor === 'porcentaje' ? '#166534' : '#1e40af'">
              {{ element.tipoValor | uppercase }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="porcentaje">
          <th mat-header-cell *matHeaderCellDef>%</th>
          <td mat-cell *matCellDef="let element"><span class="text-xs font-mono">{{ element.porcentaje ? (element.porcentaje + '%') : '-' }}</span></td>
        </ng-container>

        <ng-container matColumnDef="valorFijo">
          <th mat-header-cell *matHeaderCellDef>Fijo</th>
          <td mat-cell *matCellDef="let element"><span class="text-xs font-mono">{{ element.valorFijo ? ('Bs ' + element.valorFijo) : '-' }}</span></td>
        </ng-container>

        <ng-container matColumnDef="activo">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let element">
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full"
              [style.background]="element.activo === 1 ? '#dcfce7' : '#f3f4f6'"
              [style.color]="element.activo === 1 ? '#166534' : '#6b7280'">
              {{ element.activo === 1 ? 'ACTIVO' : 'INACTIVO' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="responsableEmail">
          <th mat-header-cell *matHeaderCellDef>Responsable</th>
          <td mat-cell *matCellDef="let element"><span class="text-xs">{{ element.responsableEmail }}</span></td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let element"><span class="text-xs">{{ element.createdAt | date:'dd/MM/yyyy HH:mm' }}</span></td>
        </ng-container>

        <ng-container matColumnDef="acciones" stickyEnd>
          <th mat-header-cell *matHeaderCellDef style="width: 120px; text-align: center;">Acciones</th>
          <td mat-cell *matCellDef="let element" style="width: 120px; text-align: center;">
            <div class="flex items-center justify-center gap-1">
              <button title="Editar" (click)="openEditForm(element)"
                [disabled]="!puedeEditar || element.activo === 0"
                [style.opacity]="element.activo === 0 ? '0.4' : '1'"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #93c5fd; border-radius: 6px; background: #eff6ff; cursor: pointer;"
                onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">edit</mat-icon>
              </button>
              <button [disabled]="!puedeEditar" [title]="element.activo === 1 ? 'Desactivar' : 'Activar'" (click)="toggleActivo(element)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border-radius: 6px; cursor: pointer;"
                [style.border]="element.activo === 1 ? '1px solid #fecaca' : '1px solid #bbf7d0'"
                [style.background]="element.activo === 1 ? '#fef2f2' : '#f0fdf4'"
                onmouseover="this.style.opacity='0.8'" onmouseout="this.style.opacity='1'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px;"
                  [style.color]="element.activo === 1 ? '#dc2626' : '#16a34a'">
                  {{ element.activo === 1 ? 'toggle_on' : 'toggle_off' }}
                </mat-icon>
              </button>
              <button title="Ver Historial" (click)="verHistorial(element)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #e9d5ff; border-radius: 6px; background: #faf5ff; cursor: pointer;"
                onmouseover="this.style.background='#f3e8ff'" onmouseout="this.style.background='#faf5ff'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #7c3aed;">history</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell text-center text-gray-400 py-8" [attr.colspan]="displayedColumns.length">
            No se encontraron comisiones
          </td>
        </tr>
      </table>
    </div>

    <!-- Cards Mobile -->
    <div class="lg:hidden space-y-3 p-4">
      <div *ngFor="let element of dataSource.filteredData; let i = index"
        class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
        [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">

        <div class="flex items-center justify-between p-3 cursor-pointer"
          (click)="toggleCard(i)"
          [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full shrink-0"
              [style.background]="element.activo === 1 ? '#dcfce7' : '#f3f4f6'"
              [style.color]="element.activo === 1 ? '#166534' : '#6b7280'">
              {{ element.activo === 1 ? 'ACTIVO' : 'INACTIVO' }}
            </span>
            <span class="text-xs font-semibold text-gray-700 truncate">{{ getBancoNombre(element.bancoId) }}</span>
          </div>
          <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
            [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>

        <div *ngIf="expandedCardId === i" class="px-3 pb-3 border-t border-gray-100">
          <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Tipo Cuenta</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ getTipoCuentaLabel(element.tipoCuenta) }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Tipo Valor</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ element.tipoValor | uppercase }}</p>
            </div>
            <div class="col-span-2">
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Tipo Operación</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ getTipoOperacionLabel(element.tipoOperacion) }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Porcentaje</span>
              <p class="text-gray-700 font-mono font-medium mt-0.5">{{ element.porcentaje ? (element.porcentaje + '%') : '-' }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Valor Fijo</span>
              <p class="text-gray-700 font-mono font-medium mt-0.5">{{ element.valorFijo ? ('Bs ' + element.valorFijo) : '-' }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Responsable</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ element.responsableEmail }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Fecha</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ element.createdAt | date:'dd/MM/yyyy HH:mm' }}</p>
            </div>
          </div>
          <div class="flex gap-2 mt-3 pt-3 border-t border-gray-100">
            <button title="Editar" (click)="openEditForm(element)"
              [disabled]="!puedeEditar || element.activo === 0"
              [style.opacity]="element.activo === 0 ? '0.4' : '1'"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #93c5fd; border-radius: 8px; background: #eff6ff; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #2563eb;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #2563eb;">edit</mat-icon>
              Editar
            </button>
            <button [disabled]="!puedeEditar" [title]="element.activo === 1 ? 'Desactivar' : 'Activar'" (click)="toggleActivo(element)"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border-radius: 8px; cursor: pointer; font-size: 0.75rem; font-weight: 600;"
              [style.border]="element.activo === 1 ? '1px solid #fecaca' : '1px solid #bbf7d0'"
              [style.background]="element.activo === 1 ? '#fef2f2' : '#f0fdf4'"
              [style.color]="element.activo === 1 ? '#dc2626' : '#16a34a'">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px;"
                [style.color]="element.activo === 1 ? '#dc2626' : '#16a34a'">
                {{ element.activo === 1 ? 'toggle_on' : 'toggle_off' }}
              </mat-icon>
              {{ element.activo === 1 ? 'Desactivar' : 'Activar' }}
            </button>
            <button title="Historial" (click)="verHistorial(element)"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #e9d5ff; border-radius: 8px; background: #faf5ff; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #7c3aed;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #7c3aed;">history</mat-icon>
              Historial
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="dataSource.filteredData.length === 0" class="text-center text-gray-400 py-8">
        No se encontraron comisiones
      </div>
    </div>

    <!-- Paginación -->
    <div class="p-4">
      <mat-paginator
        [length]="paginationMeta.total"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="paginationMeta.page - 1"
        (page)="onPageChange($event)"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>
</div>
